import { type Theme } from '@mui/material/styles'

const darkTheme: Partial<Theme> = {
  customPalette: {
    onElements: {
      outline: '#A5ACBC',
      selected: '#293846',
      elevated: '#27282D',
      onElevated: '#F3F3F4',
      overlay: '#A5ACBC',
      ripple: '#128096',
      skeleton: '#E5E5EF',
    },
    alternative: {
      onAlternativeColor: '#0D0E13',
      alternativeColor1: '#5FCFF0',
      alternativeColor2: '#F5AD4D',
      alternativeColor3: '#F7E04D',
      alternativeColor4: '#F18AB3',
      alternativeColor5: '#5ACF4D',
      alternativeColor6: '#55E1DA',
      alternativeColor7: '#FFE2FF',
      alternativeColor8: '#B9B9FB',
    },
    brand: {
      firstClass: '#12628F',
      secondClass: '#427990',
      businessFirstClassPro: '#1F2F66',
      businessFirstClass: '#464645',
      tgvMax1: '#1B878F',
      tgvMax2: '#D2E100',
      ouigo: '#E5006D',
      inoui1: '#B31B43',
      inoui2: '#AAA69D',
      eurostar: '#0B223D',
      ter: '#034EA2',
      carteAbonnement: '#007398',
      carteLiberte: '#9B2743',
      carteAvantageBackground: '#221F23',
      carteAvantagePointsBackground: '#ADFF2F', // TODO: https://jira.vsct.fr/browse/SIBR-392
      carteAvantage: '#CACACA',
      carteAvantageLeClub: '#BA9B4F',
    },
    system: {
      success: '#6BDB64',
      warning: '#ED8744',
      info: '#7BBFFD',
      warningBackground: '#221F23',
      neutralBackground: '#3C4047',
      infoBackground: '#172435',
      successBackground: '#152726',
      dangerBackground: '#240D12',
      notification: '#FF5072',
      cart: '#F7E04D',
      cartHover: '#F4D300',
    },
    background: {
      default: '#27282D', // Figma: Background
      paper: '#0D0E13', // Figma: Surface
      main: '#00C0F2',
    },
  },
}

const lightTheme: Partial<Theme> = {
  customPalette: {
    onElements: {
      outline: '#A3A3A3',
      selected: '#DCE4F0',
      elevated: '#F5F6F7',
      onElevated: '#0D0E13',
      overlay: '#848B9B',
      ripple: '#DCE4F0',
      skeleton: '#E5E5EF',
    },
    alternative: {
      onAlternativeColor: '#0D0E13',
      alternativeColor1: '#1BBBE9',
      alternativeColor2: '#EC8724',
      alternativeColor3: '#F4D300',
      alternativeColor4: '#EB5893',
      alternativeColor5: '#13BB00',
      alternativeColor6: '#14AAA3',
      alternativeColor7: '#FFD6FF',
      alternativeColor8: '#9B9BF9',
    },
    brand: {
      firstClass: '#B8D9F0',
      secondClass: '#DAEAF3',
      businessFirstClassPro: '#A2BBEE',
      businessFirstClass: '#464645',
      tgvMax1: '#1B878F',
      tgvMax2: '#D2E100',
      ouigo: '#E5006D',
      inoui1: '#B31B43',
      inoui2: '#AAA69D',
      eurostar: '#0B223D',
      ter: '#034EA2',
      carteAbonnement: '#007398',
      carteLiberte: '#9B2743',
      carteAvantageBackground: '#221F23',
      carteAvantagePointsBackground: '#ADFF2F', // TODO: https://jira.vsct.fr/browse/SIBR-392
      carteAvantage: '#CACACA',
      carteAvantageLeClub: '#BA9B4F',
    },
    system: {
      warning: '#AE4713',
      success: '#007C33',
      info: '#1364C3',
      warningBackground: '#FFF2EC',
      successBackground: '#EEF7F2',
      infoBackground: '#EFF3FA',
      dangerBackground: '#FFF0F0',
      neutralBackground: '#EAEDF3',
      cart: '#F4D300',
      notification: '#CD0037',
      cartHover: '#CAA500',
    },
    background: {
      default: '#F5F6F7', // Figma: Background
      paper: '#FFFFFF', // Figma: Surface
      main: '#225490',
    },
  },
}

export const customPalette = (prefersDarkMode: boolean): Partial<Theme> => (prefersDarkMode ? darkTheme : lightTheme)
